import { useState } from "react";
import { api } from "../lib/api.js";
import { validEmail } from "../lib/format.js";

const EMPTY = { company: "", person: "", email: "", branch: "", note: "" };

export default function Join({ settings }) {
  const [f, setF] = useState(EMPTY);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => {
    setF((prev) => ({ ...prev, [k]: e.target.value }));
    setErr("");
  };

  const send = async (e) => {
    e.preventDefault();
    if (!f.company.trim()) return setErr("Bitte den Firmennamen angeben.");
    if (!validEmail(f.email)) {
      return setErr("Diese E-Mail-Adresse können wir nicht lesen. Bitte nochmals prüfen.");
    }
    setBusy(true);
    try {
      await api.apply(f);
      setDone(true);
    } catch (ex) {
      setErr(
        ex.message ||
          `Die Anmeldung liess sich nicht übermitteln. Bitte nochmals versuchen oder direkt an ${settings.contact} schreiben.`
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="join" id="mitmachen">
      <div className="join-grid">
        <div>
          <p className="eyebrow">Mitglied werden</p>
          <h2>Komm einmal vorbei, bevor du dich entscheidest.</h2>
          <p className="join-lead">
            Wir nehmen Firmen auf, die in den letzten Jahren gegründet wurden und von den Inhabern
            selbst geführt sind. Pro Branche halten wir die Zahl klein, damit niemand am Tisch dem
            anderen die Kunden abgräbt.
          </p>
          <ol className="steps">
            <li>
              <b>1</b>
              <span>Du meldest deine Firma über das Formular an.</span>
            </li>
            <li>
              <b>2</b>
              <span>Wir melden uns innert einer Woche und laden dich zum nächsten Anlass ein.</span>
            </li>
            <li>
              <b>3</b>
              <span>Nach dem Besuch entscheidest du, ob du dabei bleibst.</span>
            </li>
          </ol>
        </div>

        <div className="join-form">
          {done ? (
            <div className="join-done">
              <b>Anmeldung ist bei uns.</b>
              <p>
                Wir schauen sie am nächsten Vorstandsabend an und melden uns innert einer Woche bei{" "}
                {f.person.trim() || "dir"}. Bis dahin findest du uns in der LinkedIn-Gruppe.
              </p>
              <a
                className="join-submit"
                href={settings.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn-Gruppe öffnen
              </a>
            </div>
          ) : (
            <form onSubmit={send} noValidate>
              <h3>Firma anmelden</h3>

              <div className="field">
                <label htmlFor="ju-company">Firma *</label>
                <input
                  id="ju-company"
                  value={f.company}
                  onChange={set("company")}
                  placeholder="Muster GmbH"
                  autoComplete="organization"
                />
              </div>
              <div className="field">
                <label htmlFor="ju-person">Ansprechperson</label>
                <input
                  id="ju-person"
                  value={f.person}
                  onChange={set("person")}
                  placeholder="Vor- und Nachname"
                  autoComplete="name"
                />
              </div>
              <div className="field">
                <label htmlFor="ju-email">E-Mail *</label>
                <input
                  id="ju-email"
                  type="email"
                  value={f.email}
                  onChange={set("email")}
                  placeholder="name@firma.ch"
                  autoComplete="email"
                />
              </div>
              <div className="field">
                <label htmlFor="ju-branch">Branche</label>
                <input
                  id="ju-branch"
                  value={f.branch}
                  onChange={set("branch")}
                  placeholder="Handwerk, Beratung, Technologie ..."
                />
              </div>
              <div className="field" style={{ marginBottom: 18 }}>
                <label htmlFor="ju-note">Was macht ihr?</label>
                <textarea
                  id="ju-note"
                  value={f.note}
                  onChange={set("note")}
                  placeholder="Zwei Sätze reichen."
                />
              </div>

              <button className="join-submit" type="submit" disabled={busy}>
                {busy ? "Wird übermittelt ..." : "Anmeldung senden"}
              </button>
              {err ? (
                <p className="join-error" role="alert">
                  {err}
                </p>
              ) : null}
              <p className="join-trust">
                Kein Beitrag im ersten Jahr · Antwort innert einer Woche · Deine Angaben sieht nur
                der Vorstand
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
